'use client';

import Image from 'next/image';
import Button from '../ui/button/submit/Button';
import { IconFriends } from '../icons';
import { useShareActions } from '@/hooks/useShareActions';

type ShareSectionProps = {
  url?: string;
  text?: string; // 分享到 LINE 時前綴文字
};

const ShareSection = ({ url, text }: ShareSectionProps) => {
  const { shareUrl, hasUrl, handleShareToFB, handleShareToLine, handleCopy } = useShareActions({
    url,
    text,
  });

  return (
    <div className="my-5">
      {/* 分享到 LINE */}
      <div className="d-flex align-items-center justify-content-between py-3 border-bottom">
        <div className="d-flex align-items-center">
          <Image
            src="https://d1q14jmvwk39e0.cloudfront.net/public/assets/images/icon/icon_share_social_line.png"
            alt="line"
            width={48}
            height={48}
          />
          <span className="ms-2 fs-sm-1">分享到 LINE</span>
        </div>
        <Button size="md" color="brand" onClick={handleShareToLine} disabled={!hasUrl}>
          分享
        </Button>
      </div>

      {/* 分享到 FB */}
      <div className="d-flex align-items-center justify-content-between py-3 border-bottom">
        <div className="d-flex align-items-center">
          <Image
            src="https://d1q14jmvwk39e0.cloudfront.net/public/assets/images/icon/icon_share_social_fb.png"
            alt="fb"
            width={48}
            height={48}
          />
          <span className="ms-2 fs-sm-1">分享到 FB</span>
        </div>
        <Button size="md" color="brand" onClick={handleShareToFB} disabled={!hasUrl}>
          分享
        </Button>
      </div>

      {/* 複製連結 */}
      <div className="d-flex align-items-center justify-content-between py-3">
        <div className="d-flex align-items-center flex-grow-1">
          <div
            className="text-white bg-primary rounded-3 d-flex justify-content-center align-items-center flex-shrink-0"
            style={{ width: '48px', height: '48px' }}
          >
            <IconFriends width={28} />
          </div>
          <div className="ms-2 pe-2 flex-grow-1">
            <span className="fs-sm-1">複製連結</span>
            <input type="text" value={shareUrl} readOnly className="mt-1" />
          </div>
        </div>
        <Button size="md" color="brand" onClick={handleCopy} disabled={!hasUrl}>
          複製
        </Button>
      </div>
    </div>
  );
};

export default ShareSection;
